import React from 'react';
import './About.css';

function About() {
  return (
    <div className="about">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <h1 className="fade-in">About Mndini Technologies</h1>
          <p className="about-hero-subtitle fade-in">
            Delivering excellence in IT solutions for over 15 years
          </p>
        </div>
      </section>

      {/* Company Overview */}
      <section className="section section-light">
        <div className="container">
          <div className="about-content">
            <div className="about-text">
              <h2>Who We Are</h2>
              <p>
                Mndini Technologies is a leading software development and IT consultancy firm with over 
                15 years of expertise in the industry. We specialize in transforming business challenges 
                into innovative technology solutions.
              </p>
              <p>
                Our team of experienced professionals brings deep knowledge in application development, 
                system architecture, and IT infrastructure. We focus primarily on building robust business 
                applications for web and mobile platforms, helping organizations modernize their technology 
                stack and streamline operations.
              </p>
            </div>
            <div className="about-image">
              <div className="image-placeholder">
                <span className="placeholder-icon">🚀</span>
                <p>Innovation & Excellence</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Expertise Areas */}
      <section className="section">
        <div className="container">
          <div className="section-title">
            <h2>Our Expertise</h2>
            <p>Comprehensive knowledge across multiple technology domains</p>
          </div>

          <div className="expertise-grid">
            <div className="expertise-card card">
              <div className="expertise-icon">💻</div>
              <h3>Application Development</h3>
              <p>
                Expert development of web and mobile business applications using modern frameworks 
                and best practices. We build scalable, maintainable solutions tailored to your needs.
              </p>
              <ul className="expertise-list">
                <li>Web Applications (Python, React, PHP)</li>
                <li>Mobile Applications</li>
                <li>Enterprise Solutions</li>
                <li>API Development & Integration</li>
              </ul>
            </div>

            <div className="expertise-card card">
              <div className="expertise-icon">🔄</div>
              <h3>Legacy System Migration</h3>
              <p>
                Seamlessly modernize your outdated systems with our proven migration strategies. 
                We ensure minimal disruption while maximizing performance improvements.
              </p>
              <ul className="expertise-list">
                <li>System Analysis & Planning</li>
                <li>Data Migration</li>
                <li>Platform Modernization</li>
                <li>Post-Migration Support</li>
              </ul>
            </div>

            <div className="expertise-card card">
              <div className="expertise-icon">📊</div>
              <h3>Business Analysis</h3>
              <p>
                Strategic technology consulting to align IT solutions with business objectives. 
                We help identify opportunities and optimize processes.
              </p>
              <ul className="expertise-list">
                <li>Requirements Analysis</li>
                <li>Process Optimization</li>
                <li>Technology Strategy</li>
                <li>Solution Architecture</li>
              </ul>
            </div>

            <div className="expertise-card card">
              <div className="expertise-icon">🌐</div>
              <h3>Networking & Infrastructure</h3>
              <p>
                Design and implementation of reliable IT infrastructure and network solutions 
                to support your business operations.
              </p>
              <ul className="expertise-list">
                <li>Network Design & Setup</li>
                <li>Cloud Infrastructure</li>
                <li>Server Configuration</li>
                <li>Security Implementation</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Our Approach */}
      <section className="section section-dark">
        <div className="container">
          <div className="section-title">
            <h2>Our Approach</h2>
            <p>How we deliver exceptional results</p>
          </div>

          <div className="approach-steps">
            <div className="approach-step">
              <div className="step-number">01</div>
              <h3>Discovery & Analysis</h3>
              <p>
                We begin by thoroughly understanding your business needs, challenges, and goals 
                to create a tailored solution strategy.
              </p>
            </div>

            <div className="approach-step">
              <div className="step-number">02</div>
              <h3>Design & Planning</h3>
              <p>
                Our team designs comprehensive solutions with detailed architecture and 
                implementation plans to ensure success.
              </p>
            </div>

            <div className="approach-step">
              <div className="step-number">03</div>
              <h3>Development & Testing</h3>
              <p>
                We build robust applications using industry best practices, with rigorous 
                testing to ensure quality and reliability.
              </p>
            </div>

            <div className="approach-step">
              <div className="step-number">04</div>
              <h3>Deployment & Support</h3>
              <p>
                Smooth deployment with comprehensive training and ongoing support to ensure 
                your success with the solution.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="section section-light">
        <div className="container">
          <div className="section-title">
            <h2>Why Choose Mndini Technologies</h2>
          </div>

          <div className="grid grid-3">
            <div className="value-card">
              <h4>🎯 15+ Years Experience</h4>
              <p>
                Over a decade and a half of proven expertise delivering successful 
                IT projects across various industries.
              </p>
            </div>

            <div className="value-card">
              <h4>🏆 Quality First</h4>
              <p>
                We prioritize code quality, security, and performance in every solution 
                we deliver.
              </p>
            </div>

            <div className="value-card">
              <h4>🤝 Client-Focused</h4>
              <p>
                Your success is our priority. We work closely with you throughout the 
                entire project lifecycle.
              </p>
            </div>

            <div className="value-card">
              <h4>⚡ Modern Technology</h4>
              <p>
                We stay current with the latest technologies and frameworks to deliver 
                cutting-edge solutions.
              </p>
            </div>

            <div className="value-card">
              <h4>📈 Scalable Solutions</h4>
              <p>
                Our applications are built to grow with your business, ensuring long-term 
                value and adaptability.
              </p>
            </div>

            <div className="value-card">
              <h4>💬 Clear Communication</h4>
              <p>
                Transparent project management with regular updates and open communication 
                channels.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
